const LIMITE = 200;

/**
 * El cuerpo remoto viaja como texto y puede no ser JSON (un 502 del proxy, por ejemplo).
 *
 * Definida ANTES de quien la usa: el build del panel pasa ESLint
 * (`@typescript-eslint/no-use-before-define`) y lo rompe si se declara después.
 */
function parsear(remote: any): any {
	if (!remote) {
		return null;
	}
	if (typeof remote === 'object') {
		return remote;
	}
	try {
		return JSON.parse(remote);
	} catch (e) {
		return null;
	}
}

/** El aviso es un snackbar: un volcado de 4 KB no cabe ni se lee. */
function recortar(texto: string): string {
	return texto.length > LIMITE ? texto.substring(0, LIMITE - 1) + '…' : texto;
}

/**
 * N-73 (arreglo D) — el motivo real de un envío fallido a la Intranet.
 *
 * `ApiHelper.handleErrors` traduce cualquier 500 a un aviso genérico e ignora el
 * cuerpo de la respuesta, así que quien pulsaba el botón de enviar no podía
 * distinguir «falta la provincia» de «se ha caído la red». Desde el arreglo A del
 * backend ese cuerpo trae el motivo exacto:
 *
 *   { message: '<mensaje de Guzzle, con el token ya redactado>',
 *     remote:  '{"message":"Bad request","errors":[{"path":"extras.0.amount", …}]}' }
 *
 * Devuelve `null` cuando no hay nada aprovechable: entonces el panel sigue con su
 * aviso de siempre. Nunca inventa un motivo.
 */
export function syncErrorMessage(error: any): string | null {
	const data = error && error.response ? error.response.data : null;
	if (!data) {
		return null;
	}

	const remote = parsear(data.remote);

	if (remote && Array.isArray(remote.errors) && remote.errors.length > 0) {
		const detalle = remote.errors
			.map(e => [e.path, e.message].filter(Boolean).join(': '))
			.filter(Boolean)
			.join(' · ');
		if (detalle) {
			return recortar(detalle);
		}
	}

	if (remote && typeof remote.message === 'string' && remote.message !== '') {
		return recortar(remote.message);
	}

	if (typeof data.message === 'string' && data.message !== '') {
		return recortar(data.message);
	}

	return null;
}
